module.exports = __webpack_public_path__ + "media/images/gift/gift-title-cfca5b131d8290b452e711fa8164544f.png";